import styled from 'styled-components';

import { Col, Row, breakpoints } from '@notino/react-styleguide-v20';

export const StyledDeliveryAndPaymentWrapper = styled(Row)`
  justify-content: center;
  margin-top: 1.25rem;
  @media (min-width: ${breakpoints.md}) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const StyledColumn = styled(Col)`
  width: 50%;
  padding: 0;
  @media (max-width: ${breakpoints.md}) {
    padding-bottom: 4rem;
    width: 100%;
  }
`;

export const StyledDeliveryColumn = styled(StyledColumn)`
  @media (min-width: ${breakpoints.md}) {
    padding-right: 2rem;
  }
`;
